const ranking = [
  { rank: 1, title: '本月最受欢迎91免费在线视频合集', heat: '播放 158.6万', tag: 'TOP1', up: true },
  { rank: 2, title: '91福利在线视频频道精选推荐', heat: '播放 132.3万', tag: '热门', up: true },
  { rank: 3, title: '免费视频在线观看人气排行榜精选', heat: '播放 115.8万', tag: '新晋', up: true },
  { rank: 4, title: '91免费视频网站热门专题回顾', heat: '播放 98.4万', tag: '', up: false },
  { rank: 5, title: '免费高清视频在线最佳画质推荐', heat: '播放 87.1万', tag: '', up: true },
];

export default function SectionRanking() {
  return (
    <section id="ranking" className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[800px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 text-center mb-2">热门榜单</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">91麻豆免费视频网站实时热门内容排行，看看大家都在看什么</p>

        <div className="space-y-3">
          {ranking.map((item, i) => (
            <a
              key={i}
              href="#media"
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 hover:bg-background-50 transition-all duration-200 cursor-pointer group"
            >
              <div className={`w-9 h-9 rounded-lg flex items-center justify-center font-bold text-sm font-heading flex-shrink-0 ${
                item.rank === 1 ? 'bg-accent-500 text-white' :
                item.rank === 2 ? 'bg-foreground-400 text-white' :
                item.rank === 3 ? 'bg-secondary-400 text-white' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.title}</h3>
                <span className="text-xs text-foreground-500">{item.heat}</span>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                {item.tag && (
                  <span className="text-xs font-medium bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full whitespace-nowrap">{item.tag}</span>
                )}
                <div className="flex items-center gap-1 text-xs text-foreground-500">
                  {item.up ? (
                    <i className="ri-arrow-up-line text-green-500"></i>
                  ) : (
                    <i className="ri-subtract-line"></i>
                  )}
                </div>
                <i className="ri-arrow-right-s-line text-foreground-400 opacity-0 group-hover:opacity-100 transition-opacity"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}